import React from 'react';

import { JobStatusEnum } from '@medely/types';
import { Divider } from '@medely/web-components';
import { Box, Button, CircularProgress } from '@medely/ui-kit';
import { CompletedShiftGeneralInfo } from './CompletedShiftGeneralInfo';
import { CompletedShiftPaymentInfo } from './CompletedShiftPaymentInfo';
import { CompletedShiftLayoutProps } from './interface';
import { useProNavigate } from '../../../contexts/NavigationContext';
import { useCurrentUser } from '../../../hooks';
import { FixedFooterLayout } from '@mp/components/FixedFooterLayout';

export const CompletedShiftLayout = ({ job, disputeCard }: CompletedShiftLayoutProps) => {
  const { navigate } = useProNavigate();
  const { isAgency, isSaas } = useCurrentUser();

  if (!job) {
    return <CircularProgress />;
  }

  const hidePaymentSection =
    isAgency ||
    isSaas ||
    [JobStatusEnum.NoShow, JobStatusEnum.LateCancellation, JobStatusEnum.MissedShift].includes(
      job.status as JobStatusEnum,
    );

  const content = (
    <>
      {!!disputeCard ? <Box mb={3}>{disputeCard}</Box> : null}
      {hidePaymentSection ? null : (
        <>
          <Box py={3}>
            <CompletedShiftPaymentInfo job={job} />
          </Box>
          <Divider thick />
        </>
      )}
      <Box py={3}>
        <CompletedShiftGeneralInfo job={job} />
      </Box>
    </>
  );

  if (job.eligible_for_self_serve && !job.active_self_service) {
    return (
      <FixedFooterLayout
        footerContent={
          <Box width="100%">
            <Button
              fullWidth
              onClick={() =>
                (navigate as (route: 'EditClockTimes', params: { jobId: string }) => void)(
                  'EditClockTimes',
                  { jobId: String(job.id) },
                )
              }
            >
              Edit clock times
            </Button>
          </Box>
        }
      >
        {content}
      </FixedFooterLayout>
    );
  }

  return <>{content}</>;
};
